module.exports = __webpack_public_path__ + "static/img/GF.7fedb345.png";